import React, { Component } from "react";

/* Components */
import InitialSetupBase from "../../../../components/InitialSetupBase";
import AdjustPhoto from "../../../../components/AdjustPhoto";

class UploadPhoto extends Component {

    render() {

        return(
            <InitialSetupBase title={"Add a photo"} description={"A clear, professional portrait helps captains and crew agents recognise you."}>
                <AdjustPhoto />
            </InitialSetupBase>
        );

    }

}

export default UploadPhoto;